module.exports = __webpack_public_path__ + "media/images/icons/filled/aliwangwang-5352f71c18e865b1058d5bc0b0614ab0.svg";